export const hasJsonFile = (files) => {
  if (!files || files.length === 0) return false;
  return files.some((file) => {
    if (!file || !file.name) return false;
    const filename = file.name;
    return filename.toLowerCase().endsWith(".json");
  });
};
